export default __webpack_public_path__ + "assets/04d.480c02b3.svg";